module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/submitting-entity-tile.component.scss
// module id = ./src/app/submission/components/submitting-entity-tile.component.scss
// module chunks = main